import { Observable } from 'rxjs';
import Paginate from '../interfaces/paginate';
import { HttpClient, ListParams } from './http-client';
import Token from '../interfaces/token';
import Maintenance from '../interfaces/maintenance';

export class TokenService extends HttpClient {
  index(params: ListParams): Observable<Paginate<Token>> {
    return this.get<Paginate<Token>>(`/api/tokens`, params);
  }

  store(
    token: Token
  ): Observable<{ plainTextToken: string; accessToken: Token }> {
    return this.post<{ plainTextToken: string; accessToken: Token }>(
      `/api/tokens`,
      token
    );
  }

  show(id: string): Observable<Token> {
    return this.get<Token>(`/api/tokens/${id}`);
  }

  exists(name: string): Observable<Token> {
    return this.get<Token>(`/api/tokens/exists/${name}`);
  }

  update(id: string, token: Token): Observable<Token> {
    return this.put<Token>(`/api/tokens/${id}`, token);
  }

  destroy(id: string): Observable<Maintenance> {
    return this.delete<Maintenance>(`/api/tokens/${id}`);
  }
}
